import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Box, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import LoadingIcon from "../../../../../../components/LoadingIcon";
import AnchorPopper from "../../../../../../components/forms/AnchorPopper";
import { StyledTextField } from "../../../../../../components/forms/styles/formFieldStyles";

const JiraPriority = ({ priorityField, isLoading }) => {
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext();

  const hasError = !!touched.priority && !!errors.priority;
  const errorMessage =
    hasError && typeof errors.priority === "string" ? errors.priority : "";

  const priorityLabel = useMemo(() => {
    const hasValue = values.priority;
    const labelText = hasValue ? "Priority" : "Select priority";

    return <Typography variant="caption">{labelText}</Typography>;
  }, [values.priority]);

  return (
    <>
      {priorityField?.allowedValues &&
        (isLoading ? (
          <LoadingIcon size={25} />
        ) : (
          <Autocomplete
            options={priorityField?.allowedValues || []}
            value={values.priority}
            onChange={(_, newValue) => setFieldValue("priority", newValue)}
            getOptionLabel={(option) => option?.value || ""}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            popupIcon={<ExpandMoreIcon />}
            PopperComponent={AnchorPopper}
            renderOption={(props, option) => (
              <Box component="li" {...props}>
                <Typography variant="caption">{option.value}</Typography>
              </Box>
            )}
            renderInput={(params) => (
              <StyledTextField
                {...params}
                margin="dense"
                label={priorityLabel}
                fullWidth
                required={priorityField?.required}
                error={hasError}
                helperText={errorMessage}
                onBlur={handleBlur}
              />
            )}
          />
        ))}
    </>
  );
};

export default JiraPriority;
